'use client';

import React from 'react';
import Link from 'next/link';
import { ArrowRight, Zap } from 'lucide-react';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden hero-grid pt-16">
      <div className="absolute top-1/4 left-1/4 w-96 h-96 orb-purple pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 orb-pink pointer-events-none" />
      <div className="absolute top-1/2 right-1/3 w-64 h-64 orb-cyan pointer-events-none" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-10 text-center w-full">
        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full border text-xs sm:text-sm font-medium mb-8"
          style={{ borderColor: 'rgba(42,157,143,0.4)', background: 'rgba(42,157,143,0.08)', color: 'var(--secondary)' }}
        >
          <Zap size={14} />
          Music Momentum Marketplace
        </div>

        {/* Headline */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
          <span className="gradient-text-cyan">Turn Music Momentum</span>
          <br />
          <span style={{ color: 'var(--foreground)' }}>Into A Market.</span>
        </h1>

        <p
          className="text-base sm:text-lg md:text-xl max-w-2xl mx-auto mb-10 sm:mb-12 px-2 leading-relaxed"
          style={{ color: 'var(--muted-foreground)' }}
        >
          A controlled marketplace where fans buy and sell{' '}
          <strong style={{ color: 'var(--secondary)' }}>Momentum Campaign Tokens</strong> tied to music anticipation and momentum.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4">
          <Link
            href="/sign-up-login-screen"
            className="btn-primary text-sm sm:text-base px-6 sm:px-8 py-3 sm:py-3.5 glow-teal w-full sm:w-auto justify-center"
          >
            Get Started
          </Link>
          <Link
            href="/music-discovery-feed"
            className="btn-secondary text-sm sm:text-base px-6 sm:px-8 py-3 sm:py-3.5 w-full sm:w-auto justify-center"
          >
            <ArrowRight size={18} />
            Explore Campaigns
          </Link>
        </div>
      </div>
    </section>
  );
}